import { FromProduct } from "@catchoftheday/analytics";

import { ProductCardDataFragment } from "@personalisation/generated/graphql";

export const getMockRecommendedProduct = ({
  id,
}: {
  id?: string;
}): ProductCardDataFragment => {
  const productTitle = `Recommended Product ${id}`;
  return {
    __typename: "Product" as const,
    id: id || "123456",
    title: productTitle,
    ratingsSummary: {
      __typename: "RatingsSummary" as const,
      numberOfRatings: 75,
      averageRating: 4.5,
    },
    assets: {
      __typename: "ProductAssets" as const,
      hero: {
        __typename: "Image" as const,
        url: "https://static.devcat.ch/images/product/0000/0818/5773408789f26095525527.jpg",
        altText: productTitle,
      },
    },
    brand: {
      __typename: "Brand" as const,
      name: "Palmolive",
      slug: "palmolive",
    },
    bestOffer: {
      __typename: "Offer" as const,
      id: "84782",
      clubExclusive: false,
      clubFreeShipping: true,
      freeShipping: false,
      badges: ["short-dated"],
      sellPrice: {
        amount: 699,
      },
      seller: {
        __typename: "Seller" as const,
        id: "1",
        name: "Catch",
      },
    },
    options: [],
    sellable: true,
    slug: "3-x-palmolive-naturals-soap-gold-4pk-90g-216178",
    priceTag: {
      priceDiscount: {
        label: "Price drop",
        percentageLabel: "30% off",
        endDate: "2022-01-01T12:23:15+10:00",
      },
      topLabel: "From",
      priceLabel: {
        wasPrice: {
          amount: 2999,
        },
        price: {
          amount: 1999,
        },
        saving: {
          label: "Save",
          savingAmount: {
            amount: 1000,
          },
        },
      },
      clubSellPrice: {
        amount: 14999,
      },
      clubExclusive: false,
      enabled: true,
      retailPriceDisclaimer: {
        description: "Limited time only",
      },
      __typename: "PriceTag" as const,
    },
    adult: false,
  };
};
export const mockRecommendedProducts: ProductCardDataFragment[] = [
  {
    __typename: "Product" as const,
    id: "216178",
    title: "3 x Palmolive Naturals Soap Gold 4pk 90g",
    adult: false,
    ratingsSummary: {
      __typename: "RatingsSummary" as const,
      numberOfRatings: 75,
      averageRating: 4.5,
    },
    assets: {
      __typename: "ProductAssets" as const,
      hero: {
        __typename: "Image" as const,
        url: "https://static.devcat.ch/images/product/0000/0818/5773408789f26095525527.jpg",
        altText: "3 x Palmolive Naturals Soap Gold 4pk 90g",
      },
    },
    brand: {
      __typename: "Brand" as const,
      name: "Palmolive",
      slug: "palmolive",
    },
    bestOffer: {
      __typename: "Offer" as const,
      id: "84782",
      clubExclusive: false,
      clubFreeShipping: true,
      freeShipping: false,
      badges: [],
      sellPrice: {
        amount: 699,
      },
      seller: {
        __typename: "Seller" as const,
        id: "1",
        name: "Catch",
      },
    },
    options: [],
    sellable: true,
    slug: "3-x-palmolive-naturals-soap-gold-4pk-90g-216178",
    priceTag: {
      priceDiscount: {
        label: "Price drop",
        percentageLabel: "30% off",
        endDate: "2022-01-01T12:23:15+10:00",
      },
      topLabel: "From",
      priceLabel: {
        wasPrice: {
          amount: 2999,
        },
        price: {
          amount: 1999,
        },
        saving: {
          label: "Save",
          savingAmount: {
            amount: 1000,
          },
        },
      },
      clubSellPrice: {
        amount: 14999,
      },
      clubExclusive: false,
      enabled: true,
      retailPriceDisclaimer: {
        description: "Limited time only",
      },
    },
  },
];

export const mockFromProduct: FromProduct = {
  from_product_ids: [123540],
  from_product_offer_id: 1354354,
  from_product_displayed_price: 10.0,
};
